export type CabinetSectionKey =
  | 'couple'
  | 'organizer'
  | 'tasks'
  | 'budget'
  | 'guests'
  | 'bookings';

export interface CabinetSection {
  key: CabinetSectionKey;
  title: string;
  placeholder: string;
  /** Budget is the only section that embeds a live view instead of text. */
  needsViewLink?: boolean;
}

/**
 * Fixed set of sections of the client cabinet ("личный кабинет пары").
 *
 * Standardisation is the point: the organizer picks the sections with
 * checkboxes instead of assembling a Notion-like page by hand. The content
 * inside each section stays an ordinary editable block, so the flexibility is
 * still there — only the skeleton is fixed.
 */
export const CABINET_SECTIONS: CabinetSection[] = [
  {
    key: 'couple',
    title: 'О паре',
    placeholder: 'Имена, дата и место свадьбы — заполните под конкретную пару.',
  },
  {
    key: 'organizer',
    title: 'Об организаторе',
    placeholder: 'Кто ведёт свадьбу, как связаться, ссылки на соцсети.',
  },
  {
    key: 'tasks',
    title: 'Задачи',
    placeholder: 'Что нужно сделать и к какому сроку.',
  },
  {
    key: 'budget',
    title: 'Смета',
    placeholder: 'Смета ещё не опубликована.',
    needsViewLink: true,
  },
  {
    key: 'guests',
    title: 'Гости',
    placeholder: 'Список гостей, рассадка, ответы на приглашение.',
  },
  {
    key: 'bookings',
    title: 'Бронирования',
    placeholder: 'Отель, трансфер, подрядчики и подтверждения.',
  },
];

export const DEFAULT_CABINET_SECTIONS: CabinetSectionKey[] =
  CABINET_SECTIONS.map(section => section.key);
